import {
    type EventActionResponseType,
    type EventActionRequestType
} from "./type";
import {
    request
} from "../request";

const CancelSubEvent = async (params: EventActionRequestType): Promise<EventActionResponseType> => {
    return await request<EventActionResponseType>("/events/cancelSubEvent", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default CancelSubEvent;
